import React, { useState } from "react";
import Login from "./section/login";
import Register from "./section/register";

const Auth = () => {
  const [isLogin, setIsLogin] = useState(true);

  const handleRegister = () => {
    setIsLogin(false);
  };

  const handleLogin = () => {
    setIsLogin(true);
  };
  return (
    <div>
      {isLogin ? (
        <Login handleRegister={handleRegister} />
      ) : (
        <Register handleLogin={handleLogin} />
      )}
    </div>
  );
};

export default Auth;
